(function (ng) {
    

    angular.module('mouseoverClassToggler', []);
})(window.angular);
